import {BaseModel} from '@/core/standard/BaseModel';
import {IModifierModel, IModifiers, ModifierProtocol} from '@/modules/modifiers/IModifierModel';
import ModifierService from '@/modules/modifiers/ModifierService';


const modifier = {
  name: '',
  app_text: '',
  name_es: '',
  name_en: '',
  image: '',
  min_value: 0,
  max_value: 1,
  is_quantifiable: false,
  options: [],
  deleted_options: [],
  enabled: false,
};

class ModifierModel extends BaseModel<IModifierModel, ModifierProtocol> {
  public request = 'FormData';

  constructor() {
    super(modifier, ModifierService);
  }

  public async mapRow(row: IModifierModel & { id: string | number }) {
    const fetchedRow = await this.service.getBy({query: {}, id: row.id});
    const {complete, data} = fetchedRow;
    data.deleted_options = [];

    if (complete) {
      super.mapRow(data);
    }
  }

  async modifiersProducts(protocol: ModifierProtocol): Promise<boolean | {
    total: number;
    data: any[]
  }> {
    const response = await this.service.modifiersProducts({method: 'GET', ...protocol});
    if (response && response.data) {
      return {
        data: response.data.results,
        total: response.data.total,
      };
    }
    return {data: [], total: 0};

  }

  async retrieveModifierWithOneLevel(id): Promise<boolean | IModifierModel> {
    const response = await this.service.retrieveModifierWithOneLevel({method: 'GET', id});
    if (response && response.data) {
      return response.data;

    }
    return false;
  }

  public async save(toast: any = null, toastConfig: any = {}) {
    const formData = new FormData();
    Object.keys(modifier).forEach((field) => {
      if (this[field] !== null && this[field] !== undefined) {
        if (typeof this[field] === 'object' && !(this[field] instanceof File)) {
          formData.append(field, JSON.stringify(this[field]));
        } else {
          const splittedField = field.split('_');
          const lang = localStorage.getItem('lang') || 'es';
          if (splittedField[splittedField.length - 1] !== lang) {
            formData.append(field, this[field]);
          }
        }
      }
    });

    if (!formData.get('image')) {
      if (!formData.has('image')) {
        formData.append('image', '');
      }
    } else if (formData.has('image') && !(formData.get('image') instanceof File)) {
      formData.delete('image');
    }
    const model = this.mapModel();
    // @ts-ignore
    formData.set('is_quantifiable', this.max_value > 1);
    const options = model.options.map((firstOptions) => ({
      id: firstOptions.id,
      type: firstOptions.type,
      modifiers: firstOptions.modifiers.map((secondModifiers) => ({
        id: secondModifiers.id, options:
          secondModifiers.options.map((secondOptions) => ({
            id: secondOptions.id,
            type: secondOptions.type,
            modifiers: [],
          })),
      })),
    }));
    formData.set('options', JSON.stringify(options));
    // @ts-ignore
    if (this.id) {
      // @ts-ignore
      formData.append('id', this.id);
      return this.update(formData, toast, toastConfig);
    } else {
      return this.create(formData, toast, toastConfig);
    }
  }
}

export default ModifierModel as new() => IModifiers;
